Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeFromPropsRegistry = removeFromPropsRegistry;
var _threads = require("./threads");
var viewTags = [];
function removeFromPropsRegistry(viewTag) {
    viewTags.push(viewTag);
    if (viewTags.length === 1) {
        queueMicrotask(flush);
    }
}
function flush() {
    if (__DEV__ && !global._IS_FABRIC) {
        throw new Error("[Reanimated] PropsRegistry is only available on Fabric.");
    }
    (0, _threads.runOnUI)(removeFromPropsRegistryOnUI)(viewTags);
    viewTags = [];
}
var _worklet_15952630180346_init_data = {
    code: "function removeFromPropsRegistryOnUI(viewTags){_removeFromPropsRegistry(viewTags);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/PropsRegistry.ts",
    sourceMap: '{"version":3,"names":["removeFromPropsRegistryOnUI","viewTags","_removeFromPropsRegistry"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/PropsRegistry.ts"],"mappings":"AAmBA,SAAAA,2BAASA,CAA4BC,QAAA,CAAkB,CAErDC,wBAAwB,CAACD,QAAQ,CAAC,CACpC"}',
    version: "3.5.4"
};
var removeFromPropsRegistryOnUI = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var removeFromPropsRegistryOnUI = function removeFromPropsRegistryOnUI(viewTags) {
        _removeFromPropsRegistry(viewTags);
    };
    removeFromPropsRegistryOnUI.__closure = {};
    removeFromPropsRegistryOnUI.__initData = _worklet_15952630180346_init_data;
    removeFromPropsRegistryOnUI.__workletHash = 15952630180346;
    removeFromPropsRegistryOnUI.__stackDetails = _e;
    return removeFromPropsRegistryOnUI;
}();
